"use client";

import { c as _c } from "react/compiler-runtime";
import { MinusCircle, PlusCircle } from "@untitledui/icons";
import type { FaqItem } from "@/consts/faqs";
import { MASTHEAD_TITLE_SCALE_CLASS } from "@/consts/typography";
import { cx } from "@/utils/cx";
const SUPPORT_EMAIL = "support@unilytics.app";
const supportEmailLinkClassName = "rounded-sm text-brand-secondary underline outline-hidden focus-visible:ring-2 focus-visible:ring-focus-ring focus-visible:ring-offset-2 focus-visible:ring-offset-bg-primary";
function linkSupportEmail(text: string) {
  const parts = text.split(SUPPORT_EMAIL);
  if (parts.length === 1) {
    return text;
  }
  return parts.flatMap((part, index) => {
    const nodes: React.ReactNode[] = [];
    if (part) {
      nodes.push(part);
    }
    if (index < parts.length - 1) {
      nodes.push(<a key={`email-${index}`} href={`mailto:${SUPPORT_EMAIL}`} className={supportEmailLinkClassName}>
					{SUPPORT_EMAIL}
				</a>);
    }
    return nodes;
  });
}
export default function FAQSection(t0) {
  const $ = _c(18);
  const {
    faqs,
    description,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("bg-primary", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-3 text-md font-semibold text-brand-secondary">Support</div>;
    t3 = <h2 className={cx(MASTHEAD_TITLE_SCALE_CLASS, "mb-5 font-display font-extrabold text-text-primary")}>FAQs</h2>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== description) {
    t4 = linkSupportEmail(description);
    $[4] = description;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div>{t2}{t3}<p className="text-lg text-text-tertiary">{t4}</p></div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== faqs) {
    t6 = faqs.map(_temp);
    $[8] = faqs;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <div className="flex flex-col gap-8">{t6}</div>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <div className="page-shell grid gap-8 py-12 md:grid-cols-2 md:gap-12 md:py-16 lg:gap-24">{t5}{t7}</div>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t1 || $[16] !== t8) {
    t9 = <section className={t1}>{t8}</section>;
    $[15] = t1;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}
function _temp(faq) {
  return <FAQItem key={faq.title} {...faq} />;
}
const FAQItem = t0 => {
  const $ = _c(12);
  const {
    title,
    paragraphs
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h3 className="text-md font-semibold text-text-primary">{title}</h3>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex size-5 shrink-0 items-center justify-center text-fg-quaternary"><PlusCircle aria-hidden="true" className="group-open:hidden" /><MinusCircle aria-hidden="true" className="hidden group-open:block" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <summary className="flex cursor-pointer list-none items-center justify-between gap-4 select-none">{t1}{t2}</summary>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== paragraphs) {
    t4 = paragraphs.map(_temp2);
    $[5] = paragraphs;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div className="mt-2 text-md text-text-tertiary">{t4}</div>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <details className="group">{t3}{t5}</details>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
function _temp2(paragraph, index) {
  return <p key={index} className={index > 0 ? "mt-2" : undefined}>{linkSupportEmail(paragraph)}</p>;
}